import React, { lazy, Suspense } from 'react'
import './App.css'
import Home from '../src/components/Home/Home'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

const MienBac = lazy(() => import('../src/components/MienBac/MienBac'))
const BaMien = lazy(() => import('../src/components/BaMien/BaMien'))

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Router>
          <Suspense fallback={null}>
            <Switch>
              <Route path="/mienbac/:id">
                <MienBac />
              </Route>
              <Route path="/mienbac">
                <MienBac />
              </Route>
              <Route path="/ba-mien/:id">
                <BaMien />
              </Route>
              <Route path="/ba-mien">
                <BaMien />
              </Route>
              <Route
                exact
                path="/:id"
                render={(props) => <Home id={props.match.params.id} />}
              />
              <Route exact path="/">
                <Home />
              </Route>
            </Switch>
          </Suspense>
        </Router>
      </div>
    )
  }
}

export default App
